import type { FaqContent } from "../types";

export const faq: FaqContent = {
  title: "FAQ",
  categoriesAriaLabel: "FAQ-kategorier",
  groups: [
    {
      label: "Kom godt i gang",
      items: [
        {
          q: "Hvem kan bruge UCloud AI?",
          a: "Alle forskere og studerende på Danmarks otte universiteter. Adgang sker med dit almindelige universitetslogin, og der er ingen eksterne API-nøgler. AI-forbrug kræver kredit fra dit universitets front office, som du ansøger om via en enkel ansøgningsformular direkte på UCloud. Hvis du allerede bruger UCloud, er UCloud AI allerede en del af dit projekt.",
        },
        {
          q: "Skal jeg installere noget?",
          a: "Nej. Den integrerede chatgrænseflade kører i browseren inde i UCloud, så du kan komme i gang med modellerne med det samme. Til alt andet lader det OpenAI-kompatible API dig medbringe dine egne værktøjer: Forskningskode, der allerede taler med OpenAI-agtige endpoints, fortsætter uændret.",
        },
        {
          q: "Hvad koster det?",
          a: "Forbrug afregnes i kredit på den nationale platform UCloud. Alle universiteter har adgang og kan købe kredit til AI-forbrug efter behov. Der er ingen betaling per token til udenlandske udbydere.",
        },
      ],
    },
    {
      label: "Modeller",
      items: [
        {
          q: "Hvilke modeller er i kataloget?",
          a: "Førende åbne internationale modeller fra dag ét, og kataloget opdateres løbende i takt med udviklingen. Vi støtter aktivt Danish Foundation Models i at bygge danske modeller på selve UCloud, modeller til dansk sprog, kultur og institutioner, og de er på vej. Aktuel tilgængelighed vises altid i workspace.",
        },
        {
          q: "Hvad kan jeg bruge API'et til?",
          a: "AI er ved at blive en generel teknologi for tænkning og skabelse: Den kan læse og opsummere store mængder information, analysere data og billeder, skrive og forbedre tekst, generere software og løse komplekse problemer. Den kan også kombinere disse evner: tage en vag idé, ræsonnere over den, søge relevant information og hjælpe med at forvandle den til et færdigt resultat. Evner, der før krævede teams af specialister, bliver i stigende grad tilgængelige for alle, lige ved siden af dine data. Fordi UCloud AI taler standard-OpenAI-protokollen, virker eksisterende biblioteker, frameworks og forskningsnotebooks uden videre.",
        },
        {
          q: "De fleste førende modeller udvikles i Kina/USA. Hvordan er det suverænt?",
          a: "En model med åbne vægte er et offentliggjort artefakt, ikke et produkt. Vi kører den selv på Bitten i Sønderborg, og den har ingen forbindelse tilbage til si skaber: ingen telemetri, ingen betaling per token, ingen vej dine data kan rejse. Dine tokens beregnes i Danmark, under dansk lov. Det er suverænitet her: fuld kontrol over modellen og de data, den arbejder på.",
        },
        {
          q: "Hvorfor betyder danske modeller noget?",
          a: "De er trænet til det danske sprog, kultur og institutioner, og de vil blive serveret i Danmark. Til forskning i danske korpora er det modellerne, du peger på noget dansk. Danish Foundation Models træner dem på UCloud i dag, med national støtte. At tilføje dem til kataloget er det naturlige næste skridt.",
        },
      ],
    },
    {
      label: "Sikkerhed & opbevaring",
      items: [
        {
          q: "Hvor behandles mine data?",
          a: "I Danmark, på den nationale supercomputer Bitten i Sønderborg. Ingen udenlandske API'er, og ikke én eneste token forlader landet. Brugere kan efter anmodning få ressourcer på Gefion, AI-supercomputeren leveret af DCAI, stadig i Danmark og med de samme garantier.",
        },
        {
          q: "Bruges mine data til træning?",
          a: "Nej. Dine data bruges aldrig til at træne modeller, hverken vores eller andres. Din forskning, dine resultater og din intellektuelle ejendomsret forbliver udelukkende din. Garantien gælder enhver forespørgsel, du sender, også følsomme forskningsdata.",
        },
        {
          q: "Kan jeg arbejde med følsomme data?",
          a: "Ja. UCloud er ISO/IEC 27001:2022-certificeret og godkendt til følsomme persondata, og UCloud AI arver det fundament. Behandlingen forbliver inden for EU, i fuld overensstemmelse med GDPR, og platformen opfylder kravene i NIS2-direktivet. Sundhedsdata, registerdata, interviewtransskriptioner: arbejd med dem uden at sende dem udenlands.",
        },
      ],
    },
    {
      label: "Fakturering",
      items: [
        {
          q: "Hvordan faktureres jeg?",
          a: "I kredit, på den nationale platform UCloud. Dit universitet køber kredit til AI-forbrug efter behov, og forbruget per token lander i din projektafregning, hvor du kan se det. Du kan også købe kredit direkte, det er ikke et krav at gå gennem dit universitets front office.",
        },
        {
          q: "Er der forbrugsgrænser?",
          a: "Kapaciteten deles på tværs af den nationale platform UCloud, og allokeringer administreres af dit universitets front office, de samme folk, der håndterer din beregning og lagring i dag. Priser per model vises, før du kører. Har du brug for kredit, kan du købe den direkte eller gennem dit universitet. Der er ingen månedlige grænser eller kvoter ud over den kredit, du køber: dit forbrug begrænses kun af din saldo.",
        },
        {
          q: "Hvorfor kredit i stedet for faktura per token?",
          a: "Fordi inferens kører på kreditsystemet på den nationale platform UCloud. Alle universiteter har adgang og kan købe kredit til AI-forbrug efter behov. Der er ingen leverandør at betale: ingen udenlandske fakturaer, ingen API-abonnementer, ingen kreditkort. Forbruget vises i dit projekts regnskab, hvor du kan følge det som enhver anden ressource.",
        },
      ],
    },
  ],
};
